<template>
  <div>
    <div>
      <div class="main-wrapper">
        <div>
          <layout-header></layout-header>
          <breadcrumb6></breadcrumb6>
          <!-- Page Content -->
          <div class="content">
            <div class="container">
              <div class="row">
                <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                  <sidebar></sidebar>
                </div>
                <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
                  <loader></loader>
                </div>
                <div class="col-md-7 col-lg-8 col-xl-9 doctor-profile" v-else>
                  <nav class="navbar navbar-expand-lg header-nav ml-md-4" style="margin-top: -10px;">
                    <div class="main-menu-wrapper patient-encounter" style="justify-content: flex-start;">
                      <div class="menu-header" style="width:auto; height:43px;">
                        <a id="menu_close" class="menu-close" href="javascript:void(0);">
                          <i class="fas fa-times"></i>
                        </a>
                      </div>
                      <ul class="main-nav">
                        <li>
                          <!-- <a href="javascript:void(0);" :class="active == 'Details' ? 'active_menu' : ''"
                            @click="active_menu('Details'); menu_close()">About
                          </a> -->
                          <a href="javascript:void(0);"
                            :class="['tab-item', active === 'Details' ? 'active_menu' : '', isDetailsTabComplete ? 'tab-complete' : 'tab-incomplete']"
                            @click="active_menu('Details'); menu_close()">
                            About
                          </a>
                        </li>
                        <li>
                          <!-- <a href="javascript:void(0);" :class="active == 'C-Details' ? 'active_menu' : ''"
                            @click="autoSaveData(); active_menu('C-Details'); menu_close()">Contact
                          </a> -->

                          <a href="javascript:void(0);"
                            :class="['tab-item', active === 'C-Details' ? 'active_menu' : '', isContactTabComplete ? 'tab-complete' : 'tab-incomplete']"
                            @click="autoSaveData(); active_menu('C-Details'); menu_close()">
                            Contact
                          </a>
                        </li>
                        <li>
                          <a href="javascript:void(0);"
                            :class="['tab-item', active === 'Education' ? 'active_menu' : '', isEducationTabComplete ? 'tab-complete' : 'tab-incomplete']"
                            @click="autoSaveData(); active_menu('Education'); menu_close()">
                            Education
                          </a>
                          <!-- <a href="javascript:void(0);" :class="active == 'Education' ? 'active_menu' : ''"
                            @click="autoSaveData(); active_menu('Education'); menu_close()">Education
                          </a> -->
                        </li>
                        <li>
                          <a href="javascript:void(0);"
                            :class="['tab-item', active === 'Experience' ? 'active_menu' : '', isExperienceTabComplete ? 'tab-complete' : 'tab-incomplete']"
                            @click="autoSaveData(); active_menu('Experience'); menu_close()">
                            Experience
                          </a>
                          <!-- <a href="javascript:void(0);" :class="active == 'Experience' ? 'active_menu' : ''"
                            @click="autoSaveData(); active_menu('Experience'); menu_close()">Experience
                          </a> -->
                        </li>
                        <li>
                          <a href="javascript:void(0);"
                            :class="['tab-item', active === 'Association' ? 'active_menu' : '', isAssociationTabComplete ? 'tab-complete' : 'tab-incomplete']"
                            @click="autoSaveData(); active_menu('Association'); menu_close()">
                            Association
                          </a>
                          <!-- <a href="javascript:void(0);" :class="active == 'Association' ? 'active_menu' : ''
                            " @click="autoSaveData(); active_menu('Association'); menu_close()">Association
                          </a> -->
                        </li>
                        <li>
                          <a href="javascript:void(0);"
                            :class="['tab-item', active === 'Biography' ? 'active_menu' : '', isBiographyTabComplete ? 'tab-complete' : 'tab-incomplete']"
                            @click="autoSaveData(); active_menu('Biography'); menu_close()">
                            Biography
                          </a>
                          <!-- <a href="javascript:void(0);" :class="active == 'Biography' ? 'active_menu' : ''"
                            @click="autoSaveData(); active_menu('Biography'); menu_close()">Biography
                          </a> -->
                        </li>
                        <li>
                          <a href="javascript:void(0);"
                            :class="['tab-item', active === 'G-Details' ? 'active_menu' : '', isGalleryTabComplete ? 'tab-complete' : 'tab-incomplete']"
                            @click="autoSaveData(); active_menu('G-Details'); menu_close()">
                            Gallery
                          </a>
                          <!-- <a href="javascript:void(0);" :class="active == 'G-Details' ? 'active_menu' : ''"
                            @click="autoSaveData(); active_menu('G-Details'); menu_close()">Gallery
                          </a> -->
                        </li>
                        <!-- Bhilwara healthcare -->
                      </ul>
                    </div>
                  </nav>
                  <form @submit.prevent="Save_Information">
                    <!-- Basic Information -->
                    <div v-if="active == 'Details'" class="card mt-2 ml-md-4">
                      <div class="card-body">
                        <div class="col-12 col-md-12">
                          <div class="d-flex form-group">
                            <div class="col-9 col-md-9 change-avatar">

                            </div>
                          </div>
                        </div>
                        <div class="row form-row">

                          <div class="col-md-4">
                            <div class="form-group">
                              <label>First Name
                                <span class="text-danger">*</span></label>
                              <input type="text" disabled v-model="doctor_profile.first_name" class="form-control" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Middle Name </label>
                              <input type="text" v-model="doctor_profile.middle_name" class="form-control"
                                oninput="this.value = this.value.replace(/[^a-zA-Z]/g, '');" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Last Name
                                <span class="text-danger">*</span></label>
                              <input type="text" disabled v-model="doctor_profile.last_name" class="form-control" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Email Id</label>
                              <input type="text" v-model="this.doctor_profile.email_id" class="form-control"
                                @input="checkEmailField" />

                              <b-button v-if="custom_email_verifieds !== 1" class="btn-info btn-sm mt-2"
                                @click="sendOTP">
                                Verify Email
                              </b-button>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Mobile Number</label><span class="text-danger"> *</span>
                              <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text">91</span>
                                </div>
                                <input type="text" :value="formattedMobileNo" class="form-control" disabled required />
                              </div>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Alternate Number</label><span class="text-danger"> *</span>
                              <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text">91</span>
                                </div>
                                <input type="text" v-model="doctor_profile.whatsapp_no" class="form-control" required
                                  maxlength="10" minlength="10" @keypress="onlyNumber" @input="validateAlternateNumber"
                                  oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="form-group">
                              <label>DOB <span style="font-size: 12px;">(Date of Birth as per Aadhar)</span>

                              </label>
                              <datepicker input-class="datepicker-here form-control digits" :format="format"
                                v-model="doctor_profile.date_of_birth" :required="true"
                                :disabled="isDateOfBirthAvailable">
                              </datepicker>

                            </div>
                          </div>

                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Aadhar No.<span class="text-danger">*</span></label>
                              <input type="text" minlength="12" maxlength="12" v-model="doctor_profile.aadhar_no"
                                class="form-control" :required="true"
                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <label>Attach Aadhar</label>
                            <div v-if="this.aadhar_card">
                              <b-button class="btn-primary btn-sm" @click="showImageModal1()"
                                v-b-modal.modal-scrolls>View Uploaded</b-button>
                            </div>
                            <input v-else type="file" class="upload" accept="image/*"
                              @change="handleAadharUpload($event)" />
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Experience (Years)</label>
                              <input type="text" v-model="doctor_profile.total_experience_in_years
                                " class="form-control" maxlength="2" minlength="1"
                                oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Council Registration Number</label>
                              <input type="text" v-model="doctor_profile.council_registration_number
                                " class="form-control" maxlength="10" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Practitioner Category</label>
                              <v-select class="mr-2" required="" label="sub_category_name"
                                placeholder="Select Practitioner Category" v-model="doctor_profile.healthcare_practitioner_category
                                  " :reduce="(option) => option.sub_category_name"
                                :options="healthcare_practitioner_categories" :disabled="doctor_profile.healthcare_practitioner_category
                                  ">
                              </v-select>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Speciality</label>
                              <v-select class="mr-2" name="speciality" required label="speciality"
                                placeholder="Select Speciality" :options="specialities" multiple
                                v-model="selectedSpecialities" @input="updatePractitionerSpeciality" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Practice Type</label>
                              <v-select class="mr-2" required="" placeholder="Select Practice Type"
                                v-model="doctor_profile.practice_type" :options="practice_types">
                              </v-select>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Gender</label>
                              <v-select class="mr-2" required="" label="gender" placeholder="Gender" v-model="doctor_profile.gender
                                " :reduce="(option) => option.gender" :options="genders">
                              </v-select>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                    <!-- /Basic Information -->

                    <!-- Doctor Gallery -->
                    <div v-if="active == 'G-Details'" class="card mt-2 ml-md-4">
                      <div class="card-body">
                        <div class="col-12 col-md-12">
                          <div class="d-md-flex flex-row flex-wrap justify-content-center">
                            <!-- Photo 1 -->
                            <div class="col-12 col-md-6 change-avatar">
                              <div class="profile-img">
                                <img
                                  v-bind:src="doctor_profile.photo_1 ? config.base_url_for_Image + doctor_profile.photo_1 : loadImg('gallary_photo.jpg')"
                                  alt="User Image" style="width:110px; height:110px;" />
                              </div>
                              <div class="upload-img">
                                <div class="change-photo-btn">
                                  <span><i class="fa fa-upload"></i> Upload</span>
                                  <input type="file" class="upload" accept="image/*"
                                    @change="onFileChange($event, 'doctor_photo_1')" />
                                </div>
                                <small class="form-text text-muted">Allowed JPG, GIF or PNG</small>
                                <small class="form-text text-muted">Max size of 2MB</small>
                              </div>
                            </div>
                            <!-- Photo 2 -->
                            <div class="col-12 col-md-6 change-avatar">
                              <div class="profile-img">
                                <img
                                  v-bind:src="doctor_profile.photo_2 ? config.base_url_for_Image + doctor_profile.photo_2 : loadImg('gallary_photo.jpg')"
                                  alt="User Image" style="width:110px; height:110px;" />
                              </div>
                              <div class="upload-img">
                                <div class="change-photo-btn">
                                  <span><i class="fa fa-upload"></i> Upload</span>
                                  <input type="file" class="upload" accept="image/*"
                                    @change="onFileChange($event, 'doctor_photo_2')" />
                                </div>
                                <small class="form-text text-muted">Allowed JPG, GIF or PNG</small>
                                <small class="form-text text-muted">Max size of 2MB</small>
                              </div>
                            </div>
                            <!-- Photo 3 -->
                            <div class="col-12 col-md-6 change-avatar">
                              <div class="profile-img">
                                <img
                                  v-bind:src="doctor_profile.photo_3 ? config.base_url_for_Image + doctor_profile.photo_3 : loadImg('gallary_photo.jpg')"
                                  alt="User Image" style="width:110px; height:110px;" />
                              </div>
                              <div class="upload-img">
                                <div class="change-photo-btn">
                                  <span><i class="fa fa-upload"></i> Upload</span>
                                  <input type="file" class="upload" accept="image/*"
                                    @change="onFileChange($event, 'doctor_photo_3')" />
                                </div>
                                <small class="form-text text-muted">Allowed JPG, GIF or PNG</small>
                                <small class="form-text text-muted">Max size of 2MB</small>
                              </div>
                            </div>
                            <!-- Photo 4 -->
                            <div class="col-12 col-md-6 change-avatar">
                              <div class="profile-img">
                                <img
                                  v-bind:src="doctor_profile.photo_4 ? config.base_url_for_Image + doctor_profile.photo_4 : loadImg('gallary_photo.jpg')"
                                  alt="User Image" style="width:110px; height:110px;" />
                              </div>
                              <div class="upload-img">
                                <div class="change-photo-btn">
                                  <span><i class="fa fa-upload"></i> Upload</span>
                                  <input type="file" class="upload" accept="image/*"
                                    @change="onFileChange($event, 'doctor_photo_4')" />
                                </div>
                                <small class="form-text text-muted">Allowed JPG, GIF or PNG</small>
                                <small class="form-text text-muted">Max size of 2MB</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /Doctor Gallery -->

                    <!-- Contact Details -->
                    <div v-if="active == 'C-Details'" class="card contact-card mt-2 ml-md-4">
                      <div class="card-body">
                        <div class="row form-row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label>Current Address </label>
                              <input type="text" v-model="doctor_profile.address" class="form-control" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label class="control-label">State</label>
                              <v-select class="mr-2" name="state" required="" label="state" placeholder="Select State"
                                oninput="this.value = this.value.replace(/[^a-z A-Z]/g, '');"
                                v-model="doctor_profile.state" :reduce="(option) => option.state" @input="
                                  get_cities();
                                doctor_profile.city = '';
                                " :options="states">
                              </v-select>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label class="control-label">City</label>
                              <v-select class="mr-2" name="city" required="" label="city" placeholder="Select City"
                                oninput="this.value = this.value.replace(/[^a-z A-Z]/g, '');"
                                v-model="doctor_profile.city" :reduce="(option) => option.city" @input="
                                  get_suburbs();" :options="cities">
                              </v-select>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label class="control-label">Pincode</label>
                              <input type="text" v-model="doctor_profile.pincode" class="form-control"
                                oninput="this.value = this.value.replace(/[^0-9]/g, '');" maxlength="6" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label class="control-label">Suburb</label>
                              <v-select class="mr-2" name="name" required="" label="zone"
                                  placeholder="Select Suburb" v-model="doctor_profile.custom_suburb"
                                   :reduce="(option) => option.name"
                                  :options="suburbs">
                                </v-select>
                              
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label class="control-label">Assistant Name <span style="color:red;">(If Any)</span>
                              </label>
                              <input type="text" v-model="doctor_profile.name_of_assistant" class="form-control"
                                oninput="this.value = this.value.replace(/[^a-z A-Z]/g, '');" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label class="control-label">Assistant Mobile No.</label>
                              <input type="text" v-model="doctor_profile.assistant_mobile" class="form-control"
                                maxlength="10" minlength="10" @keypress="onlyNumber"
                                oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label class="control-label">Assistant Whatsapp No.</label>
                              <input type="text" v-model="doctor_profile.assistant_whatsapp" class="form-control"
                                maxlength="10" minlength="10" @keypress="onlyNumber"
                                oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label class="control-label">Emergency Contact Name
                              </label>
                              <input type="text" v-model="doctor_profile.custom_emergency_contact_name"
                                class="form-control" oninput="this.value = this.value.replace(/[^a-z A-Z]/g, '');" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label class="control-label">Emergency Contact No.</label>
                              <input type="text" v-model="doctor_profile.custom_emergency_contact_number"
                                class="form-control" maxlength="10" minlength="10" @keypress="onlyNumber"
                                oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label class="control-label">Emergency Contact Relation
                              </label>
                              <input type="text" v-model="doctor_profile.custom_emergency_contact_relation"
                                class="form-control" oninput="this.value = this.value.replace(/[^a-z A-Z]/g, '');" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /Contact Details -->

                    <!-- Associated With Hospital -->
                    <div v-if="active == 'Association'" class="card ml-md-4">
                      <div class="card-body">
                        <h4 class="card-title">Associated With Doctor</h4>
                        <div v-for="(item, index) in custom_associated_doctor" :key="index">
                          <div class="row form-row">
                            <div class="col-md-5 mt-2">
                              <div class="form-group">
                                <label>Doctor Name
                                  <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" v-model="item.doctor_name"
                                  :reduce="(option) => option.name" :options="filteredDoctorDetails[index]"
                                  oninput="this.value = this.value.replace(/[^a-z A-Z]/g, '');" />
                              </div>
                            </div>
                            <div class="col-md-5 mt-2">
                              <div class="form-group">
                                <label>Since
                                  <span class="text-danger">*</span></label>
                                <input type="text" pattern="[0-9]{4}" maxlength="4"
                                  oninput="this.value = this.value.replace(/[^0-9]/g, '');" v-model="item.since"
                                  class="form-control" />
                              </div>
                            </div>
                            <div class="col-md-1 mt-2" v-if="custom_associated_doctor.length !== 1">
                              <div class="form-group mt-4" style="cursor: pointer">
                                <span class="circle" @click="remove_item('custom_associated_doctor', index)"><i
                                    class="fa fa-times" /></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="add-more">
                          <a href="javascript:void(0);" @click="add_Information('custom_associated_doctor')"
                            class="add-reg"><i class="fa fa-plus-circle"></i> {{ custom_associated_doctor.length === 0 ?
                              'Add Doctor' : 'Add More' }}</a>
                        </div>
                      </div>
                    </div>

                    <div v-if="active == 'Association'" class="card ml-md-4 mt-2">
                      <div class="card-body">
                        <h4 class="card-title">Associated With Hospital</h4>
                        <div class="text-right" style="margin-top: -39px">
                          <a href="#" data-toggle="modal" data-target="#addhospital" class="btn btn-primary btn-sm mb-3"
                            tabindex="0">Add New Hospital</a>
                        </div>
                        <div v-for="(item, index) in associated_hospitals" :key="index">
                          <div class="row form-row">
                            <div class="col-md-5 mt-2">
                              <div class="form-group">
                                <label v-if="index === 0">Hospital</label>
                                <v-select class="mr-2" name="name" required="" label="name_of_hospital"
                                  placeholder="Select Hospital" v-model="item.hospital" :disabled="!isSaveClicked"
                                  @input="set_city" :reduce="(option) => option.name"
                                  :options="filteredAssociatedLists[index]">
                                </v-select>
                              </div>
                            </div>
                            <div class="col-md-5 mt-2">
                              <div class="form-group">
                                <label v-if="index === 0">City</label>
                                <input type="text" v-if="item.hospital"
                                  style="border:1px solid rgba(200,200,200,1); width:100%; border-radius:3px; background-color:#f8f8f8; padding:6px; margin-top:2px;"
                                  disabled v-model="item.city" />
                                <input type="text" v-else
                                  style="border:1px solid rgba(200,200,200,1); width:100%; border-radius:3px; background-color:#f8f8f8; padding:6px; margin-top:2px;"
                                  disabled v-model="item.city" />
                              </div>
                            </div>
                            <div class="col-md-1" v-if="associated_hospitals.length !== 1">
                              <div class="form-group mt-4" style="cursor: pointer">
                                <span class="circle" @click="remove_item('associated_hospitals', index)"
                                  v-if="item.hospital === '' || item.city === ''"><i class="fa fa-times" /></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="add-more">
                          <a href="javascript:void(0);" @click="add_Information('associated_hospitals')"
                            class="add-reg"><i class="fa fa-plus-circle"></i> {{ associated_hospitals.length === 0 ?
                              'Add Hospital' : 'Add More' }}</a>
                        </div>
                      </div>
                    </div>
                    <div v-if="active == 'Association'" class="card ml-md-4 mt-2 p-4">

                      <h5 class="card-title">OWN Clinic</h5>

                      <div class="clinic-info" v-for="(item, index) in custom_own_clinic_details" :key="index">
                        <div class="row form-row clinic-cont">
                          <div class="col-12 col-md-4">
                            <div class="form-group">
                              <label v-if="index === 0">Clinic Name</label>
                              <input type="text" placeholder="Clinic Name" v-model="item.clinic_name"
                                oninput="this.value = this.value.replace(/[^a-z A-Z]/g, '');" class="form-control" />
                            </div>
                          </div>
                          <div class="col-12 col-md-2">
                            <div class="form-group">
                              <label v-if="index === 0">Location</label>
                              <input type="text" placeholder="Location" v-model="item.location" class="form-control"
                                oninput="this.value = this.value.replace(/[^a-z A-Z]/g, '');" />
                            </div>
                          </div>
                          <div class="col-12 col-md-2">
                            <div class="form-group">
                              <label v-if="index === 0">Since</label>
                              <input type="text" placeholder="From" v-model="item.since" class="form-control"
                                pattern="[0-9]{4}" maxlength="4"
                                oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                            </div>
                          </div>

                          <div class="col-12 col-md-2" v-if="custom_own_clinic_details.length !== 1">
                            <div class="form-group mt-md-4" style="cursor: pointer;">
                              <span class="circle" @click="remove_item('custom_own_clinic_details', index)"><i
                                  class="fa fa-times" /></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="add-more">
                        <a href="javascript:void(0);" @click="add_Information('custom_own_clinic_details')"
                          class="add-clinic"><i class="fa fa-plus-circle"></i> Add More</a>
                      </div>

                    </div>

                    <!-- Doctor Biography -->
                    <div v-if="active == 'Biography'" class="card mt-2 ml-md-4">
                      <div class="card-body">
                        <div class="form-group mb-0 testimonial">
                          <label>Biography</label>
                          <ckeditor :editor="editor" v-model="doctor_profile.about_me"></ckeditor>
                        </div>
                      </div>
                    </div>
                    <!-- /Doctor Biography -->

                    <!-- Education -->
                    <div v-if="active == 'Education'" class="card mt-2 ml-md-4">
                      <div class="card-body">
                        <div class="education-info" v-for="(item, index) in qualification_details" :key="index">
                          <div class="row form-row education-cont">
                            <div class="col-12 col-md-12 col-lg-12">
                              <div class="row form-row">
                                <div class="col-12 col-md-6 col-lg-3">
                                  <div class="form-group">
                                    <label v-if="index === 0" style="font-size: 13px;">Qualification</label>
                                    <v-select class="" name="name" required="true" label="name"
                                      placeholder="Select Qualification" v-model="item.qualification"
                                      :reduce="(option) => option.name" :options="filteredQualificationLists[index]">
                                    </v-select>
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-2">
                                  <div class="form-group">
                                    <label v-if="index === 0" style="font-size: 13px;">Year From</label>
                                    <input type="text" maxlength="4"
                                      oninput="this.value = this.value.replace(/[^0-9]/g, '');" v-model="item.year_from"
                                      class="form-control" required="true">
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-2">
                                  <div class="form-group">
                                    <label v-if="index === 0" style="font-size: 13px;">Year To</label>
                                    <input type="text" v-model="item.year_to" class="form-control" maxlength="4"
                                      required="true" @blur="validateYearTo(index)"
                                      oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..?)\../g, '$1');" />
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-2">
                                  <div class="form-group">
                                    <label v-if="index === 0" style="font-size: 13px;">College</label>
                                    <input type="text" v-model="item.college" class="form-control" required="true" />
                                  </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-2">
                                  <div class="">
                                    <label v-if="index === 0" style="font-size: 13px;">Attach Degree <span
                                        style="font-size: 10px">(pdf/jpeg Max 5MB)</span></label>
                                  </div>
                                  <input v-if="!item.file" type="file"
                                    @change="onFileChangeForQualification($event, index)" class=""
                                    style="font-size: 12px;" />
                                  <b-button v-else class="btn-primary btn-sm" @click="showImageModal(item.file)"
                                    v-b-modal.modal-scrollable style="margin-top:-50px;font-size: 12px;">View
                                    Uploaded</b-button>
                                </div>
                                <div class="col-12 col-md-6 col-lg-1" v-if="qualification_details.length !== 1">
                                  <div class="form-group" style=" cursor: pointer; text-align: end;">
                                    <span class="circle" @click="
                                      remove_item('qualification_details', index)
                                      "><i class="fa fa-times" /></span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="add-more">
                          <a href="javascript:void(0);" @click="add_Information('qualification_details')"
                            class="add-education"><i class="fa fa-plus-circle"></i> Add More</a>
                        </div>
                      </div>
                    </div>
                    <!-- /Education -->

                    <!-- Experience -->
                    <div v-if="active == 'Experience'" class="card mt-2 ml-md-4">
                      <div class="card-body">
                        <div class="row" style="display: flex; flex-direction: row">
                          <span class="ml-2">
                            <div class="form-group">
                              <input type="checkbox" id="showcharges" name="showcharges"
                                v-model="doctor_profile.custom_freelance" />
                              <label for="showcharges">
                                Freelance</label>
                            </div>
                          </span>

                          <span class="ml-4">
                            <div class="form-group">
                              <input type="checkbox" id="showcharges" name="showcharges"
                                v-model="doctor_profile.custom_own_clinic" />
                              <label for="showcharges">
                                Own Clinic</label>
                            </div>
                          </span>

                          <span class="ml-4">
                            <div class="form-group">
                              <input type="checkbox" id="showcharges" name="showcharges"
                                v-model="doctor_profile.custom_with_orthopedic_surgeon" />
                              <label for="showcharges">
                                Orthopedic Surgeon</label>
                            </div>
                          </span>

                          <span class="ml-4">
                            <div class="form-group">
                              <input type="checkbox" id="showcharges" name="showcharges"
                                v-model="doctor_profile.custom_with_hospital" />
                              <label for="showcharges">
                                Hospital</label>
                            </div>
                          </span>

                        </div>
                        <div class="card p-3 mt-2">
                          <h5 class="card-title">OWN Clinic</h5>

                          <div class="clinic-info" v-for="(item, index) in custom_practitioner_clinic" :key="index">
                            <div class="row form-row clinic-cont">
                              <div class="col-12 col-md-4">
                                <div class="form-group">
                                  <label v-if="index === 0">Clinic Name</label>
                                  <input type="text" placeholder="Clinic Name" v-model="item.clinic_name"
                                    oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '');"
                                    class="form-control" />
                                </div>
                              </div>
                              <div class="col-12 col-md-2">
                                <div class="form-group">
                                  <label v-if="index === 0">Location</label>
                                  <input type="text" placeholder="Location" v-model="item.location"
                                    oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '');"
                                    class="form-control" />
                                </div>
                              </div>
                              <div class="col-12 col-md-2">
                                <div class="form-group">
                                  <label v-if="index === 0">From</label>
                                  <input type="text" placeholder="From" v-model="item.from" class="form-control"
                                    maxlength="4" oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                                </div>
                              </div>
                              <div class="col-12 col-md-2">
                                <div class="form-group">
                                  <label v-if="index === 0">To</label>
                                  <input type="text" placeholder="To" v-model="item.to" class="form-control"
                                    maxlength="4" @blur="validateClinicTo(index)"
                                    oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                                </div>
                              </div>
                              <div class="col-12 col-md-2" v-if="custom_practitioner_clinic.length !== 1">
                                <div class="form-group mt-md-4" style="cursor: pointer;">
                                  <span class="circle" @click="remove_item('custom_practitioner_clinic', index)"><i
                                      class="fa fa-times" /></span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="add-more">
                            <a href="javascript:void(0);" @click="add_Information('custom_practitioner_clinic')"
                              class="add-clinic"><i class="fa fa-plus-circle"></i> Add More</a>
                          </div>
                        </div>

                        <div class="card p-3 mt-2">
                          <h5 class="card-title">Orthopedic Surgeon</h5>

                          <div class="clinic-info" v-for="(item, index) in custom_practitioner_orthopedic_surgeon"
                            :key="index">
                            <div class="row form-row clinic-cont">
                              <div class="col-12 col-md-4">
                                <div class="form-group">
                                  <label v-if="index === 0">Doctor Name</label>
                                  <input type="text" placeholder="Doctor Name" v-model="item.doctor_name"
                                    oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '');"
                                    class="form-control" />
                                </div>
                              </div>
                              <div class="col-12 col-md-2">
                                <div class="form-group">
                                  <label v-if="index === 0">Location</label>
                                  <input type="text" placeholder="Location" v-model="item.location"
                                    oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '');"
                                    class="form-control" />
                                </div>
                              </div>
                              <div class="col-12 col-md-2">
                                <div class="form-group">
                                  <label v-if="index === 0">From</label>
                                  <input type="text" placeholder="From" v-model="item.from" class="form-control"
                                    maxlength="4" oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                                </div>
                              </div>
                              <div class="col-12 col-md-2">
                                <div class="form-group">
                                  <label v-if="index === 0">To</label>
                                  <input type="text" placeholder="To" v-model="item.to" class="form-control"
                                    maxlength="4" @blur="validateOrthopedicTo(index)"
                                    oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                                </div>
                              </div>
                              <div class="col-12 col-md-2" v-if="custom_practitioner_orthopedic_surgeon.length !== 1">
                                <div class="form-group mt-md-4" style="cursor: pointer;">
                                  <span class="circle"
                                    @click="remove_item('custom_practitioner_orthopedic_surgeon', index)"><i
                                      class="fa fa-times" /></span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="add-more">
                            <a href="javascript:void(0);"
                              @click="add_Information('custom_practitioner_orthopedic_surgeon')" class="add-clinic"><i
                                class="fa fa-plus-circle"></i> Add More</a>
                          </div>
                        </div>

                        <div class="card p-3 mt-2">
                          <h4 class="card-title">Experience</h4>
                          <div class="text-right" style="margin-top: -39px">
                            <router-link to="/doctor/add-hospital">
                              <a href="#" class="btn btn-primary btn-sm" tabindex="0">Add New Hospital</a>
                            </router-link>
                          </div>
                          <div class="experience-info" v-for="(item, index) in experience_details" :key="index">
                            <div class="row form-row experience-cont">
                              <div class="col-12 col-md-12 col-lg-12">
                                <div class="row form-row">
                                  <div class="col-12 col-md-6 col-lg-4">
                                    <div class="form-group">
                                      <label v-if="index === 0">Hospital Name</label>
                                      <v-select class="mr-2" name="name" required="" label="name_of_hospital"
                                        placeholder="Select Hospital" v-model="item.hospital_clinic"
                                        oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '');"
                                        :reduce="(option) => option.name" :options="filteredExperienceLists[index]">
                                      </v-select>
                                    </div>
                                  </div>
                                  <div class="col-12 col-md-6 col-lg-2">
                                    <div class="form-group">
                                      <label v-if="index === 0">Year From</label>
                                      <input type="text" v-model="item.period_from" class="form-control" maxlength="4"
                                        oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..?)\../g, '$1');" />
                                    </div>
                                  </div>
                                  <div class="col-12 col-md-6 col-lg-2">
                                    <div class="form-group">
                                      <label v-if="index === 0">Year To</label>
                                      <input type="text" v-model="item.period_to" class="form-control" maxlength="4"
                                        @blur="validateExprienceTo(index)"
                                        oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..?)\../g, '$1');" />
                                    </div>
                                  </div>
                                  <div class="col-12 col-md-6 col-lg-3">
                                    <div class="form-group">
                                      <label v-if="index === 0">Designation</label>
                                      <input type="text" v-model="item.role" class="form-control" />
                                    </div>
                                  </div>
                                  <div class="col-12 col-md-6 col-lg-1" v-if="experience_details.length !== 1">
                                    <div class="form-group mt-4" style="cursor: pointer;">
                                      <span class="circle" @click="
                                        remove_item('experience_details', index)
                                        "><i class="fa fa-times" /></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="add-more">
                            <a href="javascript:void(0);" @click="add_Information('experience_details')"
                              class="add-experience"><i class="fa fa-plus-circle"></i> Add More</a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /Experience -->

                    <!-- Awards -->
                    <div v-if="active == 'Experience'" class="card mt-2 ml-md-4">
                      <div class="card-body">
                        <h4 class="card-title">Awards</h4>
                        <div class="awards-info" v-for="(item, index) in award_details" :key="index">
                          <div class="row form-row awards-cont">
                            <div class="col-12 col-md-4">
                              <div class="form-group">
                                <label v-if="index === 0">Award Name</label>
                                <input type="text" v-model="item.award_name" class="form-control"
                                  oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '');" />
                              </div>
                            </div>
                            <div class="col-12 col-md-2">
                              <div class="form-group">
                                <label v-if="index === 0">Year</label>
                                <input type="text" v-model="item.year" class="form-control" maxlength="4"
                                  oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..?)\../g, '$1');" />
                              </div>
                            </div>
                            <div class="col-12 col-md-4">
                              <div class="form-group">
                                <label v-if="index === 0">Awarder</label>
                                <input type="text" v-model="item.awarder" class="form-control"
                                  oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '');" />
                              </div>
                            </div>
                            <div class="col-12 col-md-2" v-if="award_details.length !== 1">
                              <div class="form-group mt-md-4" style="cursor: pointer;">
                                <span class="circle" @click="remove_item('award_details', index)"><i
                                    class="fa fa-times" /></span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="add-more">
                          <a href="javascript:void(0);" @click="add_Information('award_details')" class="add-award"><i
                              class="fa fa-plus-circle"></i> Add More</a>
                        </div>
                      </div>
                    </div>
                    <!-- /Awards -->

                    <!-- Bank Details -->
                    <div v-if="active == 'B-Details'" class="card mt-2 ml-md-4">
                      <div class="card-body">
                        <h4 class="card-title" style="color:navy"><i class="fa fa-bank"></i> Bank Account Details</h4>
                        <div class="col-12 col-md-12">
                          <div class="d-flex form-group">
                            <div class="col-9 col-md-9 change-avatar">
                            </div>
                          </div>
                        </div>
                        <div class="row form-row">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Bank Name</label>
                              <input type="text" class="form-control" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>Branch</label>
                              <input type="text" class="form-control" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>City</label>
                              <input type="text" class="form-control" />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>Account No.</label>
                              <input type="text" class="form-control" />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>Re Enter Account No.</label>
                              <input type="text" class="form-control" />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>IFSC Code</label>
                              <input type="text" class="form-control" />
                            </div>
                          </div>
                          <div class="col-md-4" style="margin-top:30px;">
                            <div class="change-photo-btn">
                              <span>Attach</span>
                              <input type="file" class="upload" accept="image/*" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /Bank Details -->

                    <div class="submit-section submit-btn-bottom text-left ml-md-4 align-left justify-content-left">
                      <button type="submit" class="btn btn-primary submit-btn" style="margin-top: 20px;">
                        Save Changes
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
          <layout-footer></layout-footer>
        </div>
      </div>
      <div class="modal fade custom-modal show" id="addhospital">
        <div class="modal-dialog modal-dialog-centered modal-lg doctor-profile">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Hospital</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="card">
                <div class="card-body">
                  <ul class="nav nav-tabs">
                    <li class="nav-item">
                      <a class="nav-link active" data-toggle="tab" href="#hospital-tab" style="color: #22382c;">Hospital
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" data-toggle="tab" href="#gallery-tab" style="color: #237f8f;">Hospital
                        Gallery</a>
                    </li>
                  </ul>
                  <div class="tab-content">
                    <!-- Profile Settings Form -->
                    <div class="tab-pane active" id="hospital-tab" role="tabpanel">
                      <div class="row form-row">
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label>Type Of Hospital</label>
                            <v-select class="mr-2" name="sub_category_name" required="" label="sub_category_name"
                              placeholder="Select type of Hospital" v-model="new_hospital.type_of_hospital"
                              :reduce="(option) => option.sub_category_name" :options="hospital_types">
                            </v-select>
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label>Name Of Hospital
                              <span class="text-danger">*</span></label>
                            <input v-model="new_hospital.name_of_hospital" type="text" class="form-control" value=""
                              oninput="this.value = this.value.replace(/[^a-z A-Z]/g, '');" />
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label>No Of Beds</label>
                            <input v-model="new_hospital.no_of_beds" type="text" class="form-control" value=""
                              oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label>Website</label>
                            <input v-model="new_hospital.website" type="text" class="form-control" value="" />
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label>Tagline</label>
                            <input v-model="new_hospital.hospital_tagline" type="text" class="form-control" value="" />
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label>Address</label>
                            <input v-model="new_hospital.address" type="text" class="form-control" value="" />
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label>State</label>
                            <v-select class="mr-2" name="state" required="" label="state" placeholder="Select State"
                              v-model="new_hospital.state" :reduce="(option) => option.state"
                              @input="get_cities_for_addinghospital()" :options="states">
                            </v-select>
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label>City <span class="text-danger">*</span></label>
                            <v-select class="mr-2" name="city" required="" label="city" placeholder="Select City"
                              v-model="new_hospital.city" :reduce="(option) => option.city" :options="cities">
                            </v-select>
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label>Suburb</label>
                            <input v-model="new_hospital.suburb" type="text" class="form-control" value="" />
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label>Pincode</label>
                            <input v-model="new_hospital.pincode" type="text" class="form-control" value=""
                              oninput="this.value = this.value.replace(/[^0-9]/g, '');" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="tab-pane" id="gallery-tab" role="tabpanel">
                      <div class="container">
                        <div class="row">
                          <div class="col-12 col-md-6 mb-2">
                            <div class="change-avatar">
                              <div class="profile-img m-2">
                                <img v-bind:src="new_hospital.photo_1
                                  ? config.base_url_for_Image + new_hospital.photo_1
                                  : loadImg('doctor-thumb-02.jpg')" alt="User Image" />
                              </div>
                              <div class="upload-img">
                                <div class="change-photo-btn">
                                  <span><i class="fa fa-upload"></i> Upload</span>
                                  <input type="file" class="upload" accept="image/*"
                                    @change="onFileChange($event, 'hospital_photo_1')" />
                                </div>
                                <small class="form-text text-muted">Allowed JPG, GIF, or PNG. Max size of 2MB</small>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-6 mb-4">
                            <div class="change-avatar">
                              <div class="profile-img">
                                <img v-bind:src="new_hospital.photo_2
                                  ? config.base_url_for_Image + new_hospital.photo_2
                                  : loadImg('doctor-thumb-02.jpg')" alt="User Image" />
                              </div>
                              <div class="upload-img">
                                <div class="change-photo-btn">
                                  <span><i class="fa fa-upload"></i> Upload</span>
                                  <input type="file" class="upload" accept="image/*"
                                    @change="onFileChange($event, 'hospital_photo_2')" />
                                </div>
                                <small class="form-text text-muted">Allowed JPG, GIF, or PNG. Max size of 2MB</small>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-6 mb-4">
                            <div class="change-avatar">
                              <div class="profile-img">
                                <img v-bind:src="new_hospital.photo_3
                                  ? config.base_url_for_Image + new_hospital.photo_3
                                  : loadImg('doctor-thumb-02.jpg')" alt="User Image" />
                              </div>
                              <div class="upload-img">
                                <div class="change-photo-btn">
                                  <span><i class="fa fa-upload"></i> Upload</span>
                                  <input type="file" class="upload" accept="image/*"
                                    @change="onFileChange($event, 'hospital_photo_3')" />
                                </div>
                                <small class="form-text text-muted">Allowed JPG, GIF, or PNG. Max size of 2MB</small>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-6 mb-4">
                            <div class="change-avatar">
                              <div class="profile-img">
                                <img v-bind:src="new_hospital.photo_4
                                  ? config.base_url_for_Image + new_hospital.photo_4
                                  : loadImg('doctor-thumb-02.jpg')" alt="User Image" />
                              </div>
                              <div class="upload-img">
                                <div class="change-photo-btn">
                                  <span><i class="fa fa-upload"></i> Upload</span>
                                  <input type="file" class="upload" accept="image/*"
                                    @change="onFileChange($event, 'hospital_photo_4')" />
                                </div>
                                <small class="form-text text-muted">Allowed JPG, GIF, or PNG. Max size of 2MB</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="submit-section" style="text-align: left">
                  <button @click="add_hospital()" :disabled="disabled" class="btn btn-primary submit-btn  mb-2 ml-4"
                    data-dismiss="modal" aria-label="Close">
                    Add Hospital
                  </button>
                </div>
                <!-- </form> -->
                <!-- /Profile Settings Form -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal v-model="showOTPModal" title="Enter OTP" size="md">
        <h3 class="text-center">Enter OTP</h3>
        <div class="otp-container">
          <input v-for="(value, index) in otp" :key="index" type="text" maxlength="1" class="otp-input" :value="value"
            @input="handleInput(index, $event.target.value)" @keydown.backspace="handleBackspace(index)" ref="otpFields"
            @keypress="onlyNumber" @keydown.enter.prevent="verifyOTP()" pattern="[0-9]*" autofocus />
        </div>
        <div class="mt-5 text-center">
          <b-button class="btn btn-success" @click="verifyOTP">
            Verify
          </b-button>
        </div>
      </b-modal>


      <b-modal id="modal-scrollable" scrollable title="View Document" size="lg">
        <div v-if="isPDF(selectedFile)" class="d-flex justify-content-center align-items-center">
          <embed :src="selectedFile" type="application/pdf" width="100%" height="500px" />
        </div>
        <div v-else class="d-flex justify-content-center align-items-center">
          <img :src="selectedFile" alt="Uploaded File" class="img-fluid" />
        </div>
      </b-modal>



      <b-modal id="modal-scrolls" scrollable title="View Document" size="lg">
        <div class="d-flex justify-content-center align-items-center">
          <img :src="selectedFile1" alt="Attached Degree" class="img-fluid" />
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import CommonApi from "../../../services/CommonApi";
import { mapState } from "vuex";
import config from "../../../services/CommonApi";
const images = require.context("@/assets/img/doctors");
import Datepicker from "vuejs-datepicker";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  data() {
    return {
      custom_email_verifieds: 0,
      showOTPModal: false,
      otp: ["", "", "", "", "", ""],
      isEmailVerified: false,
      isSaveClicked: false,
      selectedFile: null,
      selectedFile1: null,
      cityData: "",
      selectedQualifications: [],
      selectedSpecialities: [],
      practitioner_speciality: [],
      selectedDoctors: [],
      selectedAssociated: [],
      selectedExperience: [],
      document: null,
      document_options: ["a", "b", "c"],
      genders: [],
      active: "Details",
      editor: ClassicEditor,
      format: "dd-MM-yyyy",
      state: {
        disabledDates: {
          from: new Date(),
        },
      },
      doctor_profile: {
        name: this.$store.state.user.user_id,
        first_name: "",
        middle_name: "",
        last_name: "",
        email_id: "",
        mobile_no: "",
        whatsapp_no: "",
        gender: "",
        country: "India",
        date_of_birth: "",
        aadhar_no: "",
        aadhar_file_name: "", // Holds the file name
        aadhar_file: "",
        council_registration_number: "",
        healthcare_practitioner_category: "",
        practice_type: "",
        speciality: [],
        about_me: "",
        custom_follow_up_days: 0,
        custom_freelance: 0,
        custom_own_clinic: 0,
        custom_with_orthopedic_surgeon: 0,
        custom_with_hospital: 0,
        show_charges_at_portal: "",
        name_of_assistant: "",
        assistant_mobile: "",
        assistant_whatsapp: "",
        custom_emergency_contact_name: "",
        custom_emergency_contact_number: "",
        custom_emergency_contact_relation: "",
        total_experience_in_years: "",
        address: "",
        city: "",
        state: "",
        custom_suburb: "",
        pincode: "",
        photo_1: "",
        photo_2: "",
        photo_3: "",
        photo_4: "",
      },
      qualification_details: [
        { qualification: "", year_from: "", year_to: "", college: "", file_name: "", file: "" },
      ],
      experience_details: [
        { hospital_clinic: "", role: "", period_from: "", period_to: "" },
      ],
      custom_practitioner_clinic: [
        { clinic_name: "", location: "", from: "", to: "" }
      ],
      custom_own_clinic_details: [
        { clinic_name: "", location: "", since: "" }
      ],
      custom_practitioner_orthopedic_surgeon: [
        { doctor_name: "", location: "", from: "", to: "" }
      ],
      award_details: [{ award_name: "", year: "", awarder: "" }],
      custom_associated_doctor: [{ doctor_name: "", since: "" }],
      associated_hospitals: [{ hospital: "", city: "" }],
      states: [],
      cities: [],
      suburbs: [],
      specialities: [],
      ortho_hospitals: [],
      all_cities: [],
      programs: [],
      qualifications: [],
      new_doctors: [],
      modalities: [],
      schedules: [],
      appointment_types: [],
      service_units: [],
      rooms: [],
      ward_types: [],
      practice_engagement_types: [],
      surgery_types: [],
      practice_types: [],
      doctor_specialities: [],
      healthcare_practitioner_categories: [],
      showspinner: true,
      disabled: true,
      associated_hospitals_invalid: false,
      aadhar_card: "",
      hospital_types: [],
      new_hospital: {
        type_of_hospital: "",
        name_of_hospital: "",
        no_of_beds: "",
        website: "",
        hospital_tagline: "",
        address: "",
        state: "",
        city: "",
        suburb: "",
        pincode: "",
        photo_1: "",
        photo_2: "",
        photo_3: "",
        photo_4: "",
      },
      config: config,
      user_image: localStorage.getItem("userInfo")
        ? JSON.parse(localStorage.getItem("userInfo")).image
        : null,
    };
  },
  components: { Datepicker, ckeditor: CKEditor.component },
  watch: {
    new_hospital: {
      handler() {
        this.validateForm();
      },
      deep: true,
    },
  },
  computed: {

    formattedMobileNo() {
      return this.doctor_profile.mobile_no ? this.doctor_profile.mobile_no.slice(-10) : '';
    },

    isDetailsTabComplete() {
      return (
        this.doctor_profile.first_name &&
        this.doctor_profile.last_name &&
        this.doctor_profile.email_id &&
        this.doctor_profile.mobile_no &&
        this.doctor_profile.whatsapp_no &&
        this.doctor_profile.gender &&
        this.doctor_profile.date_of_birth &&
        this.doctor_profile.aadhar_no &&
        this.doctor_profile.council_registration_number &&
        this.doctor_profile.healthcare_practitioner_category &&
        this.doctor_profile.practice_type &&
        this.practitioner_speciality.length > 0 &&
        this.practitioner_speciality[0].speciality
      );
    },
    isEducationTabComplete() {
      return (
        this.qualification_details.length > 0 &&
        this.qualification_details[0].qualification &&
        this.qualification_details[0].year_from &&
        this.qualification_details[0].year_to &&
        this.qualification_details[0].college
      );
    },

    isContactTabComplete() {
      // Check if required fields in "Details" tab are filled
      return (
        this.doctor_profile.address &&
        this.doctor_profile.state &&
        this.doctor_profile.city &&
        this.doctor_profile.pincode &&
        this.doctor_profile.custom_suburb &&
        this.doctor_profile.assistant_mobile &&
        this.doctor_profile.name_of_assistant &&
        this.doctor_profile.assistant_whatsapp &&
        this.doctor_profile.custom_emergency_contact_name &&
        this.doctor_profile.custom_emergency_contact_number &&
        this.doctor_profile.custom_emergency_contact_relation
      );
    },

    isExperienceTabComplete() {
      // Check hospital experience
      const isHospitalExperienceComplete =
        this.experience_details.length > 0 &&
        this.experience_details[0].hospital_clinic &&
        this.experience_details[0].role &&
        this.experience_details[0].period_from &&
        this.experience_details[0].period_to;

      // Check if at least one practice type is selected
      const hasPracticeTypeSelected =
        this.doctor_profile.custom_freelance ||
        this.doctor_profile.custom_own_clinic ||
        this.doctor_profile.custom_with_orthopedic_surgeon ||
        this.doctor_profile.custom_with_hospital;

      // Check clinic details
      const isClinicDetailsComplete =
        this.custom_practitioner_clinic.length > 0 &&
        this.custom_practitioner_clinic[0].clinic_name &&
        this.custom_practitioner_clinic[0].location &&
        this.custom_practitioner_clinic[0].from &&
        this.custom_practitioner_clinic[0].to;

      // Check orthopedic surgeon details
      const isSurgeonDetailsComplete =
        this.custom_practitioner_orthopedic_surgeon.length > 0 &&
        this.custom_practitioner_orthopedic_surgeon[0].doctor_name &&
        this.custom_practitioner_orthopedic_surgeon[0].location &&
        this.custom_practitioner_orthopedic_surgeon[0].from &&
        this.custom_practitioner_orthopedic_surgeon[0].to;

      const isAwardDetailsComplete =
        this.award_details.length > 0 &&
        this.award_details[0].award_name &&
        this.award_details[0].year &&
        this.award_details[0].awarder;

      const result = (
        isHospitalExperienceComplete &&
        hasPracticeTypeSelected &&
        isClinicDetailsComplete &&
        isSurgeonDetailsComplete &&
        isAwardDetailsComplete
      );
      return result;
    },

    isAssociationTabComplete() {
      const isDoctorComplete =
        this.custom_associated_doctor.length > 0 &&
        this.custom_associated_doctor[0].doctor_name &&
        this.custom_associated_doctor[0].since;

      const isHospitalComplete =
        this.associated_hospitals.length > 0 &&
        this.associated_hospitals[0].hospital &&
        this.associated_hospitals[0].city;

      const isOwnClinicComplete =
        this.custom_own_clinic_details.length > 0 &&
        this.custom_own_clinic_details[0].clinic_name &&
        this.custom_own_clinic_details[0].location &&
        this.custom_own_clinic_details[0].since;

      const result = isDoctorComplete && isHospitalComplete && isOwnClinicComplete;
      return result;
    },

    isBiographyTabComplete() {
      // Check if required fields in "Details" tab are filled
      return (
        this.doctor_profile.about_me
      );
    },


    isGalleryTabComplete() {
      // Check if required fields in "Details" tab are filled
      return (
        this.doctor_profile.photo_1 &&
        this.doctor_profile.photo_2 &&
        this.doctor_profile.photo_3 &&
        this.doctor_profile.photo_4
      );
    },

    isDateOfBirthAvailable() {
      return !!this.doctor_profile.date_of_birth;
    },
    format() {
      return "yyyy-MM-dd";
    },

    filteredQualificationLists() {
      return this.qualification_details.map((item, index) => {
        const selectedInPrevious = this.qualification_details
          .slice(0, index)
          .map((d) => d.qualification);
        return this.qualifications.filter(
          (qualification) =>
            !selectedInPrevious.includes(qualification.name) &&
            !this.selectedQualifications.includes(qualification.name)
        );
      });
    },

    filteredDoctorDetails() {
      return this.custom_associated_doctor.map((item, index) => {
        const selectedInPrevious = this.custom_associated_doctor
          .slice(0, index)
          .map((d) => d.doctor);
        return this.new_doctors.filter(
          (doctor) =>
            !selectedInPrevious.includes(doctor.name) &&
            !this.selectedDoctors.includes(doctor.name)
        );
      });
    },

    filteredAssociatedLists() {
      return this.associated_hospitals.map((item, index) => {
        const selectedInPrevious = this.associated_hospitals
          .slice(0, index)
          .map((d) => d.hospital);
        return this.ortho_hospitals.filter(
          (hospital) =>
            !selectedInPrevious.includes(hospital.name) &&
            !this.selectedAssociated.includes(hospital.name)
        );
      });
    },

    filteredExperienceLists() {
      return this.experience_details.map((item, index) => {
        const selectedInPrevious = this.experience_details
          .slice(0, index)
          .map((d) => d.hospital_clinic);
        return this.ortho_hospitals.filter(
          (hospital_clinic) =>
            !selectedInPrevious.includes(hospital_clinic.name) &&
            !this.selectedExperience.includes(hospital_clinic.name)
        );
      });
    },

    ...mapState({
      user_id: (state) => state.user.user_id,
    }),
  },
  methods: {

    validateAlternateNumber(event) {
      const value = event.target.value;
      if (value.length > 0 && parseInt(value.charAt(0)) < 6) {
        this.$swal.fire({
          icon: "warning",
          title: "Invalid Number",
          text: "The number must start with 6 or higher.",
        });
        this.doctor_profile.whatsapp_no = "";
      }
    },

    validateYearTo(index) {
      const item = this.qualification_details[index];
      const yearFrom = parseInt(item.year_from, 10);
      const yearTo = parseInt(item.year_to, 10);
      if (yearTo < yearFrom) {
        this.$swal.fire({
          icon: "warning",
          title: "Invalid Year",
          text: "'Year To' must be greater than or equal to 'Year From'.",
        });
        item.year_to = "";
      }
    },

    validateClinicTo(index) {
      const item = this.custom_practitioner_clinic[index];
      const yearFrom = parseInt(item.from, 10);
      const yearTo = parseInt(item.to, 10);

      // If "Year To" is less than "Year From", reset it
      if (yearTo < yearFrom) {
        this.$swal.fire({
          icon: "warning",
          title: "Invalid Year",
          text: "'To' must be greater than or equal to 'From'.",
        });
        item.to = ""; // Clear invalid input
      }
    },


    validateOrthopedicTo(index) {
      const item = this.custom_practitioner_orthopedic_surgeon[index];
      const yearFrom = parseInt(item.from, 10);
      const yearTo = parseInt(item.to, 10);

      if (yearTo < yearFrom) {
        this.$swal.fire({
          icon: "warning",
          title: "Invalid Year",
          text: "'To' must be greater than or equal to 'From'.",
        });
        item.to = "";
      }
    },

    validateExprienceTo(index) {
      const item = this.experience_details[index];
      const yearFrom = parseInt(item.period_from, 10);
      const yearTo = parseInt(item.period_to, 10);

      if (yearTo < yearFrom) {
        this.$swal.fire({
          icon: "warning",
          title: "Invalid Year",
          text: "'Year To' must be greater than or equal to 'Year From'.",
        });
        item.period_to = "";
      }
    },

    updatePractitionerSpeciality() {
      // Ensure only the string value of the speciality is extracted
      this.practitioner_speciality = this.selectedSpecialities.map((speciality) => ({
        speciality: typeof speciality === 'string' ? speciality : speciality.speciality || speciality.name || "",
      }));
    },

    isPDF(file) {
      return file && file.endsWith('.pdf');
    },


    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },

    handleInput(index, value) {
      if (value.length > 1) {
        return;
      }
      this.otp[index] = value;
      if (value.length === 1 && index < this.otp.length - 1) {
        this.$refs.otpFields[index + 1].focus();
      }
    },

    handleBackspace(index) {
      if (this.otp[index] !== "") {
        this.otp[index] = "";
      } else if (index > 0) {
        this.$refs.otpFields[index - 1].focus();
      }
    },

    checkEmailField() {
      this.showVerifyButton = this.doctor_profile.email_id !== "";
    },


    async sendOTP() {
      try {
        // Open the OTP modal first
        this.showOTPModal = true;

        const params = new URLSearchParams();
        params.append("email", this.doctor_profile.email_id);

        const response = await CommonApi.get_data("sahaj.api.send_otp_email", params);
        if (response && response.status_code === 200) {
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: response.message,
          });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: response.message,
            showConfirmButton: true,
          });
          this.showOTPModal = false;
        }
      } catch (error) {
        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: response.message,
          showConfirmButton: true,
        });
        this.showOTPModal = false;
      }
    },


    async verifyOTP() {
      const fullOtp = this.otp.join(""); // Combine the OTP input values

      if (fullOtp.trim() === "") {
        this.$swal.fire({
          icon: "warning",
          title: "Warning",
          text: "Please enter a valid OTP.",
        });
        return;
      }

      try {
        // Prepare JSON payload
        const payload = {
          phone: this.doctor_profile.email_id,
          otp: fullOtp,
        };

        // Verify OTP API Call using JSON payload
        const response = await CommonApi.post_data("sahaj.api.verify_email_otp_code", JSON.stringify(payload));

        if (response && response.status_code === 200) {
          // OTP Verification successful
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: "Email verified successfully!",
          });

          // Hide the "Verify Email" button immediately
          this.isEmailVerified = true;

          const updatePayload = {
            custom_email_verified: 1,
            doctor_name: this.doctor_profile.name, // Set doctor's ID
          };

          const updateResponse = await CommonApi.post_data("sahaj.api.update_email_verified", JSON.stringify(updatePayload));

          if (updateResponse && updateResponse.status_code === 200) {
            this.showOTPModal = false; // Close OTP modal
            setTimeout(() => {
              window.location.reload();
            }, 1000)
          } else {
            this.$swal.fire({
              icon: "warning",
              title: "Warning",
              text: updateResponse.message || "Failed to update email verification status.",
            });
          }
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: response.message || "Invalid OTP. Please try again.",
          });
        }
      } catch (error) {
        console.error("Error verifying OTP:", error);
        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: "An error occurred while verifying the OTP. Please try again.",
        });
      }
    },

    handleAadharUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();

        // Set the file name to `aadhar_file_name`
        this.doctor_profile.aadhar_file_name = file.name;

        reader.onload = (e) => {
          // Update the `aadhar_file` with base64 data
          const base64String = e.target.result.split(",")[1];
          this.doctor_profile.aadhar_file = base64String;
        };

        // Read the file as a data URL
        reader.readAsDataURL(file);
      }
    },


    showImageModal(file) {
      const baseURL = 'https://physio.kneexpert.in';
      this.selectedFile = `${baseURL}${file}`;
      console.log('Attempting to open file at:', this.selectedFile); // Log for debugging
      this.$bvModal.show('modal-scrollable');
    },



    showImageModal1() {
      this.selectedFile1 = `https://develop-physio.kneexpert.in${this.aadhar_card}`;
    },

    onFileChangeForQualification(event, index) {
      const file = event.target.files[0];
      const reader = new FileReader();

      if (file) {
        reader.readAsDataURL(file);
        reader.onload = () => {
          const base64String = reader.result.split(',')[1]; // Extract base64 part only

          // Update the qualification details array with file name and base64 string
          this.qualification_details[index].file_name = file.name;
          this.qualification_details[index].file = base64String;
        };
      }
    },


    autoSaveData() {
      switch (this.active) {
        case 'Details':
          this.Save_New_Information();
          break;
        case 'C-Details':
          this.Save_New_Information();
          break;
        case 'Education':
          this.Save_New_Information();
          break;
        case 'Experience':
          this.Save_New_Information();
          break;
        case 'Association':
          this.Save_New_Information();
          break;
        case 'Charges':
          this.Save_New_Information();
          break;
        case 'Biography':
          this.Save_New_Information();
          break;
        case 'G-Details':
          break;

        default:
          break;
      }
    },

    Save_New_Information() {
      this.doctor_profile.custom_allow_online_prescsription = Number(this.doctor_profile.custom_allow_online_prescsription);
      this.showspinner = true;
      var data = new FormData();
      this.doctor_profile.date_of_birth = this.doctor_profile.date_of_birth ? this.convertDate(this.doctor_profile.date_of_birth) : "";
      data.append("doctor_profile", JSON.stringify(this.doctor_profile));
      data.append(
        "practitioner_speciality",
        JSON.stringify(this.practitioner_speciality)
      );
      data.append("experience_details", JSON.stringify(this.experience_details));
      data.append("qualification_details", JSON.stringify(this.qualification_details));
      data.append("award_details", JSON.stringify(this.award_details));
      data.append("custom_practitioner_clinic", JSON.stringify(this.custom_practitioner_clinic));
      data.append("custom_own_clinic_details", JSON.stringify(this.custom_own_clinic_details));
      data.append("custom_practitioner_orthopedic_surgeon", JSON.stringify(this.custom_practitioner_orthopedic_surgeon));
      data.append("associated_hospitals", JSON.stringify(this.associated_hospitals));
      data.append("custom_associated_doctor", JSON.stringify(this.custom_associated_doctor));
      CommonApi.post_data("sahaj.api.update_doctor_profile_v2", data).then(
        (res) => {
          this.showspinner = false;
          if (res && res.status_code === 200) {
            this.get_doctor_details();
          } else {
            this.$swal.fire({
              icon: "warning",
              title: "Warning",
              text: res.message,
              showConfirmButton: true,
            }).then(() => {
              window.location.reload();
            });
          }
          this.isSaveClicked = true;
        }
      );
    },


    menu_close() {
      // Code to close the sidebar here
      var $wrapper = $(".main-wrapper");
      $("html").removeClass("menu-opened");
      $(".sidebar-overlay").removeClass("opened");
      $wrapper.removeClass("slide-nav");
    },

    updatePrescriptionValue() {
      this.doctor_profile.custom_allow_online_prescsription = this.doctor_profile.custom_allow_online_prescsription ? 1 : 0;
    },



    /* Get Genders */
    async get_gender() {
      await CommonApi.get_data("sahaj.api.get_gender").then((res) => {
        this.genders = res.data;
      });
    },

    /* Get Profile Image */
    loadImg(imgPath) {
      return images("./" + imgPath);
    },

    isEducationDetailsEmpty(item) {
      return (
        !item.qualification ||
        !item.year_from ||
        !item.year_to ||
        !item.college
      );
    },

    active_menu(menu) {
      this.active = menu;
    },

    onChangeSpeciality(updateddata) {
      this.doctor_profile.speciality = [];
      updateddata.map((data) => {
        this.doctor_profile.speciality.push({
          speciality: data,
          name: data,
        });
      });
    },

    /* Change Profile Image */
    // onFileChange(e, photo) {
    //   var files = e.target.files;

    //   if (!files.length) return;
    //   this.createImage(files[0], photo);
    // },

    onFileChange(e, photo) {
      var files = e.target.files;

      if (!files.length) return;

      const file = files[0];
      const maxSizeInBytes = 2 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        this.$swal.fire({
          icon: "warning",
          title: "File Size Warning",
          text: "The file size exceeds the 2MB limit. Please upload a smaller file.",
        });
        return;
      }

      this.createImage(file, photo);
    },

    /* Create Profile Image */
    createImage(file, photo) {
      var reader = new FileReader();
      reader.onload = (e) => {
        if (photo === "main_image") {
          this.update_doctor_profile(file.name, e.target.result);
        } else if (photo === "doctor_photo_1") {
          this.doctor_gallery_photo_1_upload(file.name, e.target.result);
        } else if (photo === "doctor_photo_2") {
          this.doctor_gallery_photo_2_upload(file.name, e.target.result);
        } else if (photo === "doctor_photo_3") {
          this.doctor_gallery_photo_3_upload(file.name, e.target.result);
        } else if (photo === "doctor_photo_4") {
          this.doctor_gallery_photo_4_upload(file.name, e.target.result);
        } else if (photo === "hospital_photo_1") {
          this.hospital_gallery_photo_1_upload(file.name, e.target.result);
        } else if (photo === "hospital_photo_2") {
          this.hospital_gallery_photo_2_upload(file.name, e.target.result);
        } else if (photo === "hospital_photo_3") {
          this.hospital_gallery_photo_3_upload(file.name, e.target.result);
        } else if (photo === "hospital_photo_4") {
          this.hospital_gallery_photo_4_upload(file.name, e.target.result);
        }
      };
      reader.readAsDataURL(file);
    },

    /* Upload Image API */
    async update_doctor_profile(filename, upload_image) {
      this.$swal({
        text: "Updating Profile Photo...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let data = {
        doctor: this.$store.state.user.user_id,
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.profile_photo_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          const retrievedString = localStorage.getItem("userInfo");
          const parsedObject = JSON.parse(retrievedString);
          parsedObject.image = res.data;
          const strigifiedForStorage = JSON.stringify(parsedObject);
          localStorage.setItem("userInfo", strigifiedForStorage);
          this.$swal.fire({
            icon: "success",
            title: "Success",
            text: res.message,
            showConfirmButton: true,
          }).then(() => {
            window.location.reload();
          });
        }
      });
    },

    /* Upload Doctor Gallary Image  1 API */
    async doctor_gallery_photo_1_upload(filename, upload_image) {
      this.$swal({
        text: "Updating Galley Photo...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let data = {
        doctor: this.$store.state.user.user_id,
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.doctor_gallery_photo_1_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          this.get_doctor_details();
          this.$swal.close();
        }
      });
    },

    /* Upload Doctor Gallary Image  2 API */
    async doctor_gallery_photo_2_upload(filename, upload_image) {
      this.$swal({
        text: "Updating Galley Photo...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let data = {
        doctor: this.$store.state.user.user_id,
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.doctor_gallery_photo_2_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          this.get_doctor_details();
          this.$swal.close();
        }
      });
    },

    /* Upload Doctor Gallary Image  3 API */
    async doctor_gallery_photo_3_upload(filename, upload_image) {
      this.$swal({
        text: "Updating Galley Photo...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let data = {
        doctor: this.$store.state.user.user_id,
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.doctor_gallery_photo_3_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          this.get_doctor_details();
          this.$swal.close();
        }
      });
    },

    /* Upload Doctor Gallary Image  4 API */
    async doctor_gallery_photo_4_upload(filename, upload_image) {
      this.$swal({
        text: "Updating Galley Photo...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      let data = {
        doctor: this.$store.state.user.user_id,
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.doctor_gallery_photo_4_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          this.get_doctor_details();
          this.$swal.close();
        }
      });
    },

    /* Upload HospitaL Gallary Image 1 API */
    async hospital_gallery_photo_1_upload(filename, upload_image) {
      let data = {
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.hospital_gallery_photo_1_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          this.new_hospital.photo_1 = res.data.file_url;
        }
      });
    },

    /* Upload HospitaL Gallary Image 2 API */
    async hospital_gallery_photo_2_upload(filename, upload_image) {
      let data = {
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.hospital_gallery_photo_2_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          this.new_hospital.photo_2 = res.data.file_url;
        }
      });
    },

    /* Upload HospitaL Gallary Image 3 API */
    async hospital_gallery_photo_3_upload(filename, upload_image) {
      let data = {
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.hospital_gallery_photo_3_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          this.new_hospital.photo_3 = res.data.file_url;
        }
      });
    },

    /* Upload HospitaL Gallary Image 4 API */
    async hospital_gallery_photo_4_upload(filename, upload_image) {
      let data = {
        filename: filename,
        decode_base64: 1,
        filedata: upload_image,
      };
      await CommonApi.post_data(
        "sahaj.document.hospital_gallery_photo_4_upload",
        JSON.stringify(data)
      ).then((res) => {
        if (res && res.status_code == 200) {
          this.new_hospital.photo_4 = res.data.file_url;
        }
      });
    },

    validateForm() {
      if (
        this.new_hospital.name_of_hospital === "" ||
        this.new_hospital.city === ""
      ) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },

    /* Add Any Information */
    add_Information(type) {
      if (type === "qualification_details") {
        const allFieldsFilled = this.qualification_details.every(detail =>
          detail.qualification && detail.year_from && detail.year_to && detail.college
        );
        if (this.qualification_details.length === 0 || allFieldsFilled) {
          this.qualification_details.push({ qualification: "", year_from: "", year_to: "", college: "", file_name: "", file: "" });
        } else {
          this.$swal.fire({
            icon: "warning",
            title: "Warning",
            text: "Please make sure to select a value from the dropdown menu before adding another one.",
            showConfirmButton: true,
          });
        }
      }

      else if (type === "experience_details") {
        const allFieldsFilled = this.experience_details.every(detail =>
          detail.hospital_clinic && detail.role && detail.period_from && detail.period_to
        );
        if (this.experience_details.length === 0 || allFieldsFilled) {
          this.experience_details.push({ hospital_clinic: "", role: "", period_from: "", period_to: "" });
        } else {
          this.$swal.fire({
            icon: "warning",
            title: "Warning",
            text: "Please make sure to select a value from the dropdown menu before adding another one.",
            showConfirmButton: true,
          });
        }
      }
      else if (type === "award_details") {
        this.award_details.push({ award_name: "", year: "", awarder: "" });
      }
      else if (type === "custom_practitioner_clinic") {
        this.custom_practitioner_clinic.push({ clinic_name: "", location: "", from: "", to: "" });
      } else if (type === "custom_own_clinic_details") {
        this.custom_own_clinic_details.push({ clinic_name: "", location: "", since: "" });
      }
      else if (type === "custom_practitioner_orthopedic_surgeon") {
        this.custom_practitioner_orthopedic_surgeon.push({ doctor_name: "", location: "", from: "", to: "" });
      }
      else if (type === "associated_hospitals") {
        this.isSaveClicked = true;
        const allFields = this.associated_hospitals.every(detail =>
          detail.hospital && detail.city
        );

        if (this.associated_hospitals.length === 0 || allFields) {
          this.associated_hospitals.push({ hospital: "", city: this.cityData });
        } else {
          this.$swal.fire({
            icon: "warning",
            title: "Warning",
            text: "Please make sure to select a value from the dropdown menu before adding another one.",
            showConfirmButton: true,
          });
        }
      } else if (type === "custom_associated_doctor") {
        this.isSaveClicked = true;
        const allFields = this.custom_associated_doctor.every(detail =>
          detail.doctor_name && detail.since
        );

        if (this.custom_associated_doctor.length === 0 || allFields) {
          this.custom_associated_doctor.push({ doctor_name: "", since: "" });
        } else {
          this.$swal.fire({
            icon: "warning",
            title: "Warning",
            text: "Please make sure to select a value from the dropdown menu before adding another one.",
            showConfirmButton: true,
          });
        }
      }
    },

    /* Remove Any Information */
    remove_item(type, id) {
      if (type === "qualification_details") {
        this.qualification_details.splice(id, 1);
      } else if (type === "experience_details") {
        this.experience_details.splice(id, 1);
      } else if (type === "award_details") {
        this.award_details.splice(id, 1);
      } else if (type === "custom_practitioner_clinic") {
        this.custom_practitioner_clinic.splice(id, 1);
      } else if (type === "custom_own_clinic_details") {
        this.custom_own_clinic_details.splice(id, 1);
      } else if (type === "custom_practitioner_orthopedic_surgeon") {
        this.custom_practitioner_orthopedic_surgeon.splice(id, 1);
      }
      else if (type === "associated_hospitals") {
        this.associated_hospitals.splice(id, 1);
        this.isSaveClicked = false;
      }
      else if (type === "custom_associated_doctor") {
        this.custom_associated_doctor.splice(id, 1);
        this.isSaveClicked = false;
      }
    },

    add_hospital() {
      if (!this.disabled) {
        this.$swal({
          text: "Adding Hospital...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        var data = new FormData();
        data.append("data", JSON.stringify(this.new_hospital));
        CommonApi.post_data("sahaj.api.add_hospital", data).then((res) => {
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            });
            this.get_hospital_list();
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
          (this.new_hospital.type_of_hospital = ""),
            (this.new_hospital.name_of_hospital = ""),
            (this.new_hospital.no_of_beds = ""),
            (this.new_hospital.website = ""),
            (this.new_hospital.state = ""),
            (this.new_hospital.city = ""),
            (this.new_hospital.suburb = ""),
            (this.new_hospital.pincode = "");
        });
      }
    },

    /* Get Doctor Profile Information */
    get_doctor_details() {
      const params = new URLSearchParams();
      params.append("name", this.user_id);
      CommonApi.get_data("sahaj.api.get_doctor_details", params).then((res) => {
        this.showspinner = false;
        if (res && res.data && res.status_code === 200) {

          this.custom_email_verifieds = res.data.custom_email_verified;
          this.doctor_profile.custom_follow_up_days = res.data.custom_follow_up_days;
          this.doctor_profile.first_name = res.data.first_name;
          this.doctor_profile.custom_allow_online_prescsription = res.data.custom_allow_online_prescsription;
          this.doctor_profile.middle_name = res.data.middle_name;
          this.doctor_profile.last_name = res.data.last_name;
          this.doctor_profile.email_id = res.data.email;
          this.doctor_profile.mobile_no = res.data.mobile_phone;
          this.doctor_profile.whatsapp_no = res.data.whatsapp_no ? res.data.whatsapp_no.replace(/^91/, '') : '';
          this.doctor_profile.date_of_birth = res.data.date_of_birth;
          this.doctor_profile.gender = res.data.gender;
          this.doctor_profile.aadhar_no = res.data.aadhar_no;
          this.doctor_profile.custom_freelance = res.data.custom_freelance;
          this.custom_own_clinic = res.data.custom_own_clinic;
          this.doctor_profile.custom_with_orthopedic_surgeon = res.data.custom_with_orthopedic_surgeon;
          this.doctor_profile.custom_with_hospital = res.data.custom_with_hospital;
          this.aadhar_card = res.data.aadhar_card;
          this.doctor_profile.council_registration_number =
            res.data.council_registration_number;
          this.doctor_profile.healthcare_practitioner_category =
            res.data.healthcare_practitioner_category;
          this.doctor_profile.practice_type = res.data.practice_type;
          this.doctor_profile.about_me = res.data.about_me;
          this.doctor_profile.name_of_assistant = res.data.name_of_assistant;
          this.doctor_profile.assistant_mobile = res.data.assistant_mobile;
          this.doctor_profile.assistant_whatsapp = res.data.assistant_whatsapp;
          this.doctor_profile.custom_emergency_contact_name = res.data.custom_emergency_contact_name;
          this.doctor_profile.custom_emergency_contact_number = res.data.custom_emergency_contact_number;
          this.doctor_profile.custom_emergency_contact_relation = res.data.custom_emergency_contact_relation;
          this.doctor_profile.total_experience_in_years =
            res.data.total_experience_in_years;
          this.doctor_profile.address = res.data.address;
          this.doctor_profile.city = res.data.city;
          this.doctor_profile.state = res.data.state;
          this.doctor_profile.custom_suburb = res.data.custom_suburb;
          this.doctor_profile.pincode = res.data.pincode;
          this.doctor_profile.photo_1 = res.data.photo_1;
          this.doctor_profile.photo_2 = res.data.photo_2;
          this.doctor_profile.photo_3 = res.data.photo_3;
          this.doctor_profile.photo_4 = res.data.photo_4;
          this.doctor_profile.show_charges_at_portal =
            res.data.show_charges_at_portal;

          (this.qualification_details = []),
            (this.experience_details = []),

            this.award_details = [];
          this.custom_practitioner_clinic = [];
          this.custom_own_clinic_details = [];
          this.custom_practitioner_orthopedic_surgeon = [];
          this.associated_hospitals = [];
          this.custom_associated_doctor = [];


          this.selectedSpecialities = res.data.practitioner_speciality.map(
            (item) => item.speciality
          );

          // Also map the correct data to practitioner_speciality for form submission
          this.practitioner_speciality = res.data.practitioner_speciality.map(
            (item) => ({
              speciality: item.speciality,
            })
          );

          res.data.qualification_details.map((item) =>
            this.qualification_details.push({
              qualification: item.qualification,
              year_from: item.year_from,
              year_to: item.year_to,
              college: item.college,
              file: item.degree
            })
          );

          res.data.experience_details.map((item) =>
            this.experience_details.push({
              hospital_clinic: item.hospital_clinic,
              role: item.role,
              period_from: item.period_from,
              period_to: item.period_to,
            })
          );

          res.data.award_details.map((item) =>
            this.award_details.push({
              award_name: item.award_name,
              year: item.year,
              awarder: item.awarder,
            })
          );

          res.data.custom_practitioner_clinic.map((item) =>
            this.custom_practitioner_clinic.push({
              clinic_name: item.clinic_name,
              location: item.location,
              from: item.from,
              to: item.to
            })
          );

          res.data.custom_own_clinic_details.map((item) =>
            this.custom_own_clinic_details.push({
              clinic_name: item.clinic_name,
              location: item.location,
              since: item.since
            })
          );

          res.data.custom_practitioner_orthopedic_surgeon.map((item) =>
            this.custom_practitioner_orthopedic_surgeon.push({
              doctor_name: item.doctor_name,
              location: item.location,
              from: item.from,
              to: item.to
            })
          );

          res.data.associated_hospitals.map((item) =>
            this.associated_hospitals.push({
              hospital: item.hospital,
              city: item.city,
            })
          );

          res.data.custom_associated_doctor.map((item) =>
            this.custom_associated_doctor.push({
              doctor_name: item.doctor_name,
              since: item.since,
            })
          );

          this.get_cities();
          this.get_suburbs();
        }
      });
    },
    /* Save Doctor Informations */
    Save_Information() {

      const hasIncompleteQualifications = this.qualification_details.some((item) =>
        !item.qualification || !item.year_from || !item.year_to || !item.college
      );


      if (this.qualification_details.length === 0 || hasIncompleteQualifications) {
        this.$swal.fire({
          icon: "warning",
          title: "Qualification Details Missing",
          text: "Filling in the qualification details is mandatory. Please update your Qualification.",
          showConfirmButton: true,
        });
        return;
      }

      this.doctor_profile.custom_allow_online_prescsription = Number(this.doctor_profile.custom_allow_online_prescsription);
      this.showspinner = true;
      var data = new FormData();
      this.doctor_profile.date_of_birth = this.doctor_profile.date_of_birth ? this.convertDate(this.doctor_profile.date_of_birth) : "";
      const formattedSpecialities = this.practitioner_speciality.map((item) => ({
        speciality: item.speciality || "",
      }));
      data.append("practitioner_speciality", JSON.stringify(formattedSpecialities));
      data.append("doctor_profile", JSON.stringify(this.doctor_profile));
      data.append("experience_details", JSON.stringify(this.experience_details));
      data.append("qualification_details", JSON.stringify(this.qualification_details));
      data.append("award_details", JSON.stringify(this.award_details));
      data.append("custom_practitioner_clinic", JSON.stringify(this.custom_practitioner_clinic));
      data.append("custom_own_clinic_details", JSON.stringify(this.custom_own_clinic_details));
      data.append("custom_practitioner_orthopedic_surgeon", JSON.stringify(this.custom_practitioner_orthopedic_surgeon));
      data.append("associated_hospitals", JSON.stringify(this.associated_hospitals));
      data.append("custom_associated_doctor", JSON.stringify(this.custom_associated_doctor));
      CommonApi.post_data("sahaj.api.update_doctor_profile_v2", data).then(
        (res) => {
          this.showspinner = false;
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            }).then(() => {
              // window.location.reload();
              this.get_doctor_details();
            });
          } else {
            this.$swal.fire({
              icon: "warning",
              title: "Warning",
              text: res.message,
              showConfirmButton: true,
            }).then(() => {
              // window.location.reload();
            });
          }
          this.isSaveClicked = true;
        }
      );
    },

    //Allow User to type number only
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault();
      }
    },

    /* Convert Date to Required Format for API */
    convertDate(str) {
      if (str === null || str === "") {
        return "";
      } else {
        var date = new Date(str),
          mnth = ("0" + (date.getMonth() + 1)).slice(-2),
          day = ("0" + date.getDate()).slice(-2);
        return [date.getFullYear(), mnth, day].join("-");
      }
    },

    /* Get Healthcare Sub Categories */
    async get_healthcare_sub_categories() {
      await CommonApi.get_data(
        "sahaj.finalapi.get_healthcare_sub_categories"
      ).then((res) => {
        if (res.status_code == 200) {
          this.hospital_types = res.data;
        }
      });
    },

    /* Get Healthcare Categories */
    async get_healthcare_categories() {
      await CommonApi.get_data(
        "sahaj.finalapi.get_healthcare_sub_categories"
      ).then((res) => {
        if (res.status_code == 200) {
          this.healthcare_practitioner_categories = res.data;
        }
      });
    },

    /* Get States */
    async get_states() {
      await CommonApi.get_data("sahaj.finalapi.get_states").then((res) => {
        this.states = res.message;
      });
    },

    /* Get States For Adding Hospital */
    async get_cities_for_addinghospital() {
      this.new_hospital.city = "";
      const params = new URLSearchParams();
      params.append("state", this.new_hospital.state);
      await CommonApi.get_data("sahaj.finalapi.get_city", params).then(
        (res) => {
          this.cities = res.message;
        }
      );
    },

    /* Get All Cities */
    async get_allcities() {
      await CommonApi.get_data("sahaj.finalapi.get_city").then((res) => {
        this.all_cities = res.message;
      });
    },

    /* Get Cities */
    async get_cities() {
      // this.doctor_profile.city = "";
      const params = new URLSearchParams();
      params.append("state", this.doctor_profile.state);
      await CommonApi.get_data("sahaj.finalapi.get_city", params).then(
        (res) => {

          this.cities = res.message;
        }
      );
    },



    async get_suburbs() {
      const params = new URLSearchParams();
      params.append("city", this.doctor_profile.city);
      try {
        const res = await CommonApi.get_data("sahaj.knee_lead_portal.get_suburb", params);
        if (res.status_code === 200 && Array.isArray(res.data) && res.data.length) {
          this.suburbs = res.data;
        } else {
          this.suburbs = [];
        }
      } catch (error) {
        console.error("Error fetching suburbs:", error);
        this.suburbs = [];
      }
    },
    /* Get Doctor Specialities */
    async get_core_speciality() {
      await CommonApi.get_data("sahaj.api.get_core_speciality").then((res) => {
        this.doctor_specialities = res.message;
      });
    },

    /* Get Practice types */
    async get_practice_type() {
      await CommonApi.get_data("sahaj.api.get_practice_type").then((res) => {
        this.practice_types = res.message;
      });
    },

    /* Get Cities */
    async get_speciality_list() {
      await CommonApi.get_data("sahaj.api.get_speciality_list").then((res) => {
        this.specialities = res.data;
      });
    },

    set_city(item) {
      const selectedHospital = this.associated_hospitals.find(
        (hospital) => hospital.hospital === item
      );
      if (selectedHospital) {
        const city = item.split('-')[1];
        selectedHospital.city = city;
      }
    },

    /* Get Ortho Hospitals */
    async get_hospital_list() {
      const params = new URLSearchParams();
      await CommonApi.get_data("sahaj.api.get_hospital_list", params).then(
        (res) => {
          this.ortho_hospitals = res.data;
        }
      );
    },

    /* Get Programs */
    async get_sahaj_program() {
      await CommonApi.get_data("sahaj.api.get_sahaj_program").then((res) => {
        this.programs = res.data;
      });
    },

    /* Get Qualificatons */
    async get_qualificaton() {
      await CommonApi.get_data("sahaj.api.get_qualificaton").then((res) => {
        this.qualifications = res.data;
      });
    },

    /* Get Modalities */
    async get_modality() {
      await CommonApi.get_data("sahaj.api.get_modality").then((res) => {
        this.modalities = res.data;
      });
    },

    /* Get Schedules */
    async get_practitioner_schedule() {
      await CommonApi.get_data("sahaj.api.get_practitioner_schedule").then(
        (res) => {
          this.schedules = res.data;
        }
      );
    },

    /* Get Appointment Type */
    async get_appointment_type() {
      await CommonApi.get_data("sahaj.api.get_appointment_type").then((res) => {
        this.appointment_types = res.data;
      });
    },

    /* Get Appointment Type */
    async get_service_unit() {
      await CommonApi.get_data("sahaj.api.get_service_unit").then((res) => {
        this.service_units = res.data;
      });
    },

    /* Get Room Types */
    async get_room_type() {
      await CommonApi.get_data("sahaj.api.get_room_type").then((res) => {
        this.rooms = res.data;
      });
    },

    /* Get Ward Types */
    async get_ward_type() {
      await CommonApi.get_data("sahaj.api.get_ward_type").then((res) => {
        this.ward_types = res.data;
      });
    },

    /* Get Practice Engagement Type */
    async get_practice_engagement_type() {
      const params = new URLSearchParams();
      params.append("parent", this.user_id);
      await CommonApi.get_data(
        "sahaj.api.get_practice_engagement_type",
        params
      ).then((res) => {
        this.practice_engagement_types = res.data;
      });
    },

    /* Get Surgery Type */
    async get_surgery_type() {
      await CommonApi.get_data("sahaj.api.get_surgery_type").then((res) => {
        this.surgery_types = res.data;
      });
    },
  },
  mounted() {
    let user = localStorage.getItem("userInfo");
    if (!user) {
      this.$router.push({ name: 'login' })
    }
    this.get_doctor_details();
    this.get_gender();
    this.get_states();
    this.get_allcities();
    this.get_healthcare_categories();
    this.get_healthcare_sub_categories();
    this.get_core_speciality();
    this.get_practice_type();
    this.get_speciality_list();
    this.get_hospital_list();
    this.get_sahaj_program();
    this.get_qualificaton();
    this.get_modality();
    this.get_practitioner_schedule();
    this.get_appointment_type();
    this.get_service_unit();
    this.get_room_type();
    this.get_ward_type();
    this.get_practice_engagement_type();
    this.get_surgery_type();
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%",
      });
    }
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fas fa-chevron-up",
          down: "fas fa-chevron-down",
          next: "fas fa-chevron-right",
          previous: "fas fa-chevron-left",
        },
      });
    }

    //sidebar open close
    var $wrapper = $(".main-wrapper");
    $(".main-nav a").on("click", function (e) {
      if (
        $(this)
          .parent()
          .hasClass("has-submenu")
      ) {
        e.preventDefault();
      }
      if (!$(this).hasClass("submenu")) {
        $("ul", $(this).parents("ul:first")).slideUp(350);
        $("a", $(this).parents("ul:first")).removeClass("submenu");
        $(this)
          .next("ul")
          .slideDown(350);
        $(this).addClass("submenu");
      } else if ($(this).hasClass("submenu")) {
        $(this).removeClass("submenu");
        $(this)
          .next("ul")
          .slideUp(350);
      }
    });
    $("body").append('<div class="sidebar-overlay"></div>');
    $(document).on("click", "#mobile_btn", function () {
      $wrapper.toggleClass("slide-nav");
      $(".sidebar-overlay").toggleClass("opened");
      $("html").addClass("menu-opened");
      $("#task_window").removeClass("opened");
      return false;
    });

    $(document).on("click", "#menu_close", function () {
      $("html").removeClass("menu-opened");
      $(".sidebar-overlay").removeClass("opened");
      $("main-wrapper").removeClass("slide-nav");
    });
    $(".main-nav ul li:not(.submenu) a").click(function () {
      $("html").removeClass("menu-opened");
      $(".sidebar-overlay").removeClass("opened");
    });
  },
};
</script>
<style scoped>
.otp-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.otp-input {
  width: 40px;
  height: 40px;
  text-align: center;
  font-size: 24px;
  margin: 0 10px;
  border: none;
  border-bottom: 2px solid #403636;
  box-shadow: none;
  background-color: transparent;
  color: #140b0b;
  transition: all 0.3s ease-in-out;
  font-family: Arial, Helvetica, sans-serif;
}

.otp-input:focus {
  outline: none;
  border-bottom: 2px solid #09e5ab;
}

.new_btn:hover {
  background-color: #008080;
}

@keyframes countdown {
  from {
    stroke-dashoffset: 0px;
  }

  to {
    stroke-dashoffset: 113px;
  }
}

.tab-item {
  position: relative;
  padding-bottom: 5px;
}

.tab-complete::after {
  content: '';
  position: absolute;
  left: 0;
  /* bottom: 0; */
  margin-top: 35px;
  width: 100%;
  height: 5px;
  border-radius: 5px;
  background-color: #66cdaa;
}

.tab-incomplete::after {
  content: '';
  position: absolute;
  left: 0;
  /* bottom: 0; */
  margin-top: 35px;
  width: 100%;
  height: 5px;
  border-radius: 5px;
  background-color: red;
}

.prefix-number {
  display: inline-block;
  padding: 10px;
  background: #f0f0f0;
  border: 1px solid #ddd;
  border-right: 0;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  color: #666;
  text-align: center;
}

.form-group.d-flex input.form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.text-danger {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/kneexpert/doctor/ProfileSettings.vue